import { render } from "./CorporateHeader.vue?vue&type=template&id=199648d2&scoped=true&ts=true&lang=pug"
import script from "./CorporateHeader.vue?vue&type=script&lang=ts"
export * from "./CorporateHeader.vue?vue&type=script&lang=ts"

import "./CorporateHeader.vue?vue&type=style&index=0&id=199648d2&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-199648d2"]])

export default __exports__